import React, { useState } from 'react'
import { /*CreditCard,*/ Smartphone, Loader } from 'lucide-react'
// import { API_CONFIG } from '../../config/apiConfig'
import { formatCurrency } from '../../utils/formatters'
import apiService from '../../services/apiService'
import './AuthFlow.scss'
import authService from '../../services/authService'

const PaymentMethod = ({
  onBack,
  selectedPlan,
  registerData,
  renewSubscriptionData,
  onPaymentInitiated,
}) => {
  const [paymentMethod, setPaymentMethod] = useState('orange_money')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleProceedToPayment = async () => {
    setError('')
    setLoading(true)

    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      setLoading(false)
    } else {
      try {
        const response = await apiService.initiatePayment(
          selectedPlan.id,
          paymentMethod,
          registerData || null,
          renewSubscriptionData || null,
        )

        if (response.success) {
          onPaymentInitiated(response.data)
        } else {
          setError(
            response.error || "Erreur lors de l'initialisation du paiement",
          )
        }
      } catch (err) {
        setError('Erreur de connexion. Vérifiez votre connexion internet.')
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <div className='auth-container'>
      <div className='auth-header'>
        <h1 className='auth-title'>
          OGC<span style={{ color: 'red' }}>2</span>
          <span style={{ color: 'rgb(255, 255, 42)' }}>2</span>
          <span style={{ color: '#00d700' }}>4</span>
        </h1>
      </div>

      <div className='auth-card'>
        <h2 className='auth-card-title'>Paiement</h2>
        <p className='auth-card-subtitle'>Choisissez votre mode de paiement</p>

        <div className='payment-summary'>
          <div className='summary-row'>
            <span>Plan sélectionné</span>
            <strong>{selectedPlan.name}</strong>
          </div>
          <div className='summary-row'>
            <span>Montant à payer</span>
            <strong className='amount'>
              {formatCurrency(selectedPlan.price)}
            </strong>
          </div>
          {/* <div className='summary-note'>
            Premier mois • Renouvellement automatique
          </div> */}
        </div>

        <div className='payment-methods'>
          <label
            className={`payment-method-card ${
              paymentMethod === 'orange_money' ? 'selected' : ''
            }`}
          >
            <input
              type='radio'
              name='paymentMethod'
              value='orange_money'
              checked={paymentMethod === 'orange_money'}
              onChange={(e) => setPaymentMethod(e.target.value)}
            />
            <div className='method-content'>
              <div className='method-icon orange'>
                <Smartphone size={24} />
              </div>
              <div className='method-info'>
                <h4>Orange Money</h4>
                <p>Paiement via orange money</p>
              </div>
            </div>
          </label>

          {/* <label
            className={`payment-method-card ${paymentMethod === 'card' ? 'selected' : ''}`}
          >
            <input
              type='radio'
              name='paymentMethod'
              value='card'
              checked={paymentMethod === 'card'}
              onChange={(e) => setPaymentMethod(e.target.value)}
            />
            <div className='method-content'>
              <div className='method-icon card'>
                <CreditCard size={24} />
              </div>
              <div className='method-info'>
                <h4>Carte Bancaire</h4>
                <p>Visa ou MasterCard</p>
              </div>
            </div>
          </label> */}
        </div>

        {error && (
          <div className='auth-error'>
            {error}
            <p>
              Veuillez réessayer. Si le problème persiste, merci de nous
              contacter sur WhatsApp au{' '}
              <span
                onClick={() => {
                  window.open('https://wa.me/224621994206', '_blank')
                }}
              >
                +224 621 99 42 06
              </span>
            </p>
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '10px',
          }}
        >
          <button onClick={onBack} className='btn-text'>
            Choisir un autre plan
          </button>

          <button
            onClick={handleProceedToPayment}
            className='btn primary lg full'
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader size={20} className='btn-icon spinning' />
                Initialisation...
              </>
            ) : (
              `Payer ${formatCurrency(selectedPlan.price)}`
            )}
          </button>
        </div>

        <div className='payment-secure'>
          <p>🔒 Paiement 100% sécurisé</p>
        </div>
      </div>

      <div className='auth-footer'>
        Besoin d'aide ? Contactez-nous sur WhatsApp au{' '}
        <span
          onClick={() => {
            window.open('https://wa.me/224621994206', '_blank')
          }}
        >
          +224 621 99 42 06
        </span>
      </div>
    </div>
  )
}

export default PaymentMethod
